import {
  determinePlatformLink,
  determinePlatformLinkText,
} from "src/reusable/Functions";

import { CFooter } from "@coreui/react";
import { PropTypes } from "prop-types";
import React, { useEffect, useRef, useState } from "react";
import { nuclearn_version } from "src/App";
import { useNucAppStore } from "src/stores/NucAppStore";
import ReleaseNotesDialog from "src/reusable/components/ReleaseNotes/ReleaseNotesDialog";

const Policy = (props) => {
  return (
    <a
      href={props.href}
      target={props.target}
      rel="noopener noreferrer"
      style={{ color: props.color }}
      data-testid={props["data-testid"]}
      data-attr={props["data-attr"]}
    >
      {props.children}
    </a>
  );
};

Policy.propTypes = {
  href: PropTypes.string,
  target: PropTypes.string,
  color: PropTypes.string,
  children: PropTypes.node,
};

const TheFooter = () => {
  const footerRef = useRef(null);
  const setFooterHeight = useNucAppStore((state) => state.setFooterHeight);
  const [mounted, setMounted] = useState(false);
  const [releaseNotesOpen, setReleaseNotesOpen] = useState(false);

  const handleResize = () => {
    if (footerRef.current) {
      const height = footerRef.current.offsetHeight;
      setFooterHeight(height);
    }
  };

  useEffect(() => {
    setMounted(true);
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    if (mounted && footerRef.current) {
      setTimeout(() => {
        handleResize();
      }, 100);
    }
  }, [mounted]);

  return (
    <CFooter
      data-testid="footer-container"
      innerRef={footerRef}
      fixed={false}
      className="footer-app"
      style={{
        marginTop: "auto",
        width: `100%`,
        padding: `0 3%`,
        minHeight: "50px", // Ensure a minimum height
      }}
    >
      <div
        style={{
          display: `flex`,
          flexGrow: 1,
          justifyContent: `space-between`,
          alignItems: `center`,
        }}
      >
        <span style={{ display: `flex`, flexDirection: `column` }}>
          <span>
            <span
              data-testid="footer-text-version"
              data-attr="footer:link:view-release-notes"
              onClick={() => setReleaseNotesOpen(true)}
              style={{
                cursor: "pointer",
                color: "blue",
                textDecoration: "underline",
              }}
              title="View release notes"
            >
              v{nuclearn_version}
            </span>{" "}
            {"  |  "}
            <Policy
              data-testid="footer-link-nuclearn"
              data-attr="footer:link:platform-home"
              color="blue"
              href={determinePlatformLink()}
              target="_blank"
            >
              {determinePlatformLinkText()}
            </Policy>
            {"  |  "}
            <span data-testid="footer-text-copyright">
              &copy; {new Date().getFullYear()} Nuclearn Inc.{" "}
            </span>
          </span>
        </span>

        <ReleaseNotesDialog
          open={releaseNotesOpen}
          onClose={() => setReleaseNotesOpen(false)}
        />

        <span style={{ gap: `10px`, display: `flex` }}>
          <Policy
            data-testid="footer-link-eula"
            data-attr="footer:link:eula"
            color="gray"
            href="http://nuclearn.ai/eula/"
            target="_blank"
          >
            EULA
          </Policy>
          {"  |  "}
          <Policy
            data-testid="footer-link-terms"
            data-attr="footer:link:terms-of-service"
            color="gray"
            href="http://nuclearn.ai/terms-of-service/"
            target="_blank"
          >
            Terms Of Service
          </Policy>
          {"  |  "}
          <Policy
            data-testid="footer-link-privacy"
            data-attr="footer:link:privacy-policy"
            color="gray"
            href="http://nuclearn.ai/privacy-policy/"
            target="_blank"
          >
            Privacy Policy
          </Policy>
        </span>
      </div>
    </CFooter>
  );
};

export default React.memo(TheFooter);
